export default {
  'fdicLogo.imgAlt': 'Member FDIC & Equal Housing Lender'
};
